import { useNavigate } from 'react-router-dom';

/**
 * Navigation hook that preserves ?business_id during impersonation.
 * Drop-in replacement for useNavigate() — automatically appends
 * business_id to the target path when the agency admin is
 * viewing a business via "Log in as".
 *
 * Routes that should NEVER carry impersonation context:
 *   /admin*, /login, /forgot-password, /reset-password
 */
const SKIP_PREFIXES = ['/admin', '/login', '/forgot-password', '/reset-password'];

export function useImpersonationNavigate() {
    const navigate = useNavigate();

    return (path, options) => {
        // Only string paths — objects / numbers (-1) pass through unchanged
        if (typeof path !== 'string') {
            return navigate(path, options);
        }

        const bid = new URLSearchParams(window.location.search).get('business_id');

        if (bid && !path.includes('business_id') && !SKIP_PREFIXES.some(p => path.startsWith(p))) {
            const sep = path.includes('?') ? '&' : '?';
            return navigate(`${path}${sep}business_id=${bid}`, options);
        }

        return navigate(path, options);
    };
}
